import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import AppGroups from '../app-groups/AppGroups';
import AssessmentTypeButton from '../assessment-type-button/AssessmentTypeButton';
import ClassList from '../class-list/ClassList';
import Logo from '../logo/Logo';
import StaffLogoutButton from '../staff-logout-button/StaffLogoutButton';
import SyncButton from '../sync-button/SyncButton';
import WindowData from '../window-data/WindowData';
import { classesType } from '../../constants/prop-types';
import { ASSESSMENT_TYPE } from '../../constants/assessments';
import { getClassDataById } from '../../common/utils/classesHelpers';
import MenuButton from '../menu-button/MenuButton';

const Header = ({
    classes,
    selectAppGroup,
    selectClassId,
    selectedAppGroup,
    selectedClassId,
    syncTrigger,
    openMenu,
    setAssessmentType,
    logoutTrigger,
}) => {
    const gradeLevel = get(getClassDataById(classes, selectedClassId), 'gradeLevel');

    return (
        <header className='dashboard-header'>
            {/* Staff menu, mClass logo */}
            <div className='dashboard-header-row'>
                <MenuButton openMenu={openMenu} />
                <Logo />
                <StaffLogoutButton logoutTrigger={logoutTrigger} />
            </div>
            <div className='dashboard-header-row'>
                {/* Benchmark / PM buttons */}
                <div className='dashboard-assessment-type-row'>
                    <AssessmentTypeButton
                        assessmentType={ASSESSMENT_TYPE.BM}
                        setAssessmentType={setAssessmentType}
                    />
                    <AssessmentTypeButton
                        assessmentType={ASSESSMENT_TYPE.PM}
                        setAssessmentType={setAssessmentType}
                    />
                </div>
                <div className='dashboard-window-row'>
                    <WindowData gradeLevel={gradeLevel} />
                </div>
                <SyncButton onSync={syncTrigger} />
            </div>
            <div className='dashboard-app-group-row'>
                <AppGroups
                    selectedClassId={selectedClassId}
                    selectAppGroup={selectAppGroup}
                    selectedAppGroup={selectedAppGroup}
                />
                <ClassList
                    classes={classes}
                    selectedClassId={selectedClassId}
                    selectClassId={selectClassId}
                />
            </div>
        </header>
    );
};

Header.propTypes = {
    classes: classesType.isRequired,
    selectAppGroup: PropTypes.func.isRequired,
    selectClassId: PropTypes.func.isRequired,
    selectedAppGroup: PropTypes.string.isRequired,
    selectedClassId: PropTypes.string.isRequired,
    syncTrigger: PropTypes.func.isRequired,
    openMenu: PropTypes.func.isRequired,
    setAssessmentType: PropTypes.func.isRequired,
    logoutTrigger: PropTypes.func.isRequired,
};

export default Header;
